export default {
  items: []
}



// WEBPACK FOOTER //
// ./src/store/modules/references/state.js